import { NumberFormatter, NumberInput } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { FictionalEnergyValueResponse } from "../../FictionalEnergyValueManager/FictionalEnergyValueManager";
import { updateRowData } from "./updateRowData";

function getRedispatchAbregelungColumn(
  creationError: string | null,
  editingError: string | null
): MRT_ColumnDef<FictionalEnergyValueResponse> {
  return {
    accessorKey: "redispatchAbregelungKwh",
    header: "Redispatch-Abregelung (kWh)",
    Cell: ({ cell }) => <NumberFormatter value={Number(cell.getValue())} />,
    Edit: ({ table, row, cell }) => {
      return (
        <NumberInput
          defaultValue={Number(cell.getValue())}
          error={
            table.getState().creatingRow?.id === row.id
              ? creationError
              : editingError
          }
          placeholder="Redispatch-Abregelung (kWh)"
          onChange={(value) =>
            updateRowData({
              table,
              row,
              columnIds: ["redispatchAbregelungKwh"],
              newValues: [value]
            })
          }
        />
      );
    }
  };
}

export { getRedispatchAbregelungColumn };
